export class Param {
    get id() {
        return this.paramState.id;
    }
    get name() {
        return this.paramState.name;
    }
    get type() {
        return this.paramState.type;
    }
    set name(name) {
        this.paramState.name = name;
    }
    constructor(paramState) {
        this.paramState = paramState;
    }
    getState() {
        return this.paramState;
    }
}
